<template>
  <div class="flex column">
    <HeaderCard :title="$t('left-menu.providers')" @open="openProviderEditor"></HeaderCard>
    <el-row class="mb-10 mt-0">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <span v-if="selected.length==0 && !isFiltered" class="fs-14">Tous les producteurs <span><el-button icon="el-icon-plus" circle size="small" @click="openProviderEditor"></el-button></span></span>
        <span v-else>
          <span class="fs-14">Producteurs</span>
          <span v-if="!isFiltered">
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> Sélectionné(s)</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{selected.length}}</span>
            <el-dropdown size="small" split-button type="primary" class="ml-20">
              Actions
              <el-dropdown-menu slot="dropdown">
               <el-dropdown-item @click.native="deleteSelectedProviders"><i class="el-icon-delete"></i>Supprimer</el-dropdown-item>
               <el-dropdown-item :disabled="true"><i class="mdi mdi-file-excel"></i>Exporté CSV</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span v-else>
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> Résultats de recherche</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{cmsProviders.length}}</span>
          </span>
        </span>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <el-input
          placeholder="Rechercher un fournisseur"
          clearable
          size="small"
          v-model="searchModel"
          v-popover:popover>
          <!-- <el-dropdown slot="append" style="border-right:1px;">
              <el-button type="primary">
              Trier par<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :icon="sortIcon('customer.name')" @click.native="sortBy('customer.name')">Client</el-dropdown-item>
              <el-dropdown-item :icon="sortIcon('inv_number')" @click.native="sortBy('inv_number')">Numéro de facture</el-dropdown-item>
              <el-dropdown-item  :icon="sortIcon('updated_at')" @click.native="sortBy('updated_at')">Dernière modification</el-dropdown-item>
              <el-dropdown-item  :icon="sortIcon('date')" @click.native="sortBy('date')">Date de facturation</el-dropdown-item>
              <el-dropdown-item  :icon="sortIcon('paid_at')" @click.native="sortBy('paid_at')">Date de paiement</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-button slot="prepend" @click="showFilters=true"><i class="mdi mdi-filter-variant" style="font-size:15px;"></i></el-button> -->
        </el-input>
      </el-col>
    </el-row>
    <div class="flex center m-10">
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="currentPage"
        :total-number-of-page="totalPages"
        @click-previous="fetchPreviousPage"
        @click-next="fetchNextPage" />
    </div>
    <el-table
      :data="cmsProviders"
      stripe
      @selection-change="handleSelectionChange"
      empty-text="Aucun producteur"
      height="100%"
      v-loading="loading"
      :style="'width:' + getTableWidth  + 'px'">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      prop="name"
      fixed="left"
      label="Nom du producteur">
      <template slot-scope="scope">
        <PortausLink :id="scope.row.id" path="/settings/CMS/providers/" :label="scope.row.name"></PortausLink>
      </template>
    </el-table-column>
    <el-table-column
      prop="published"
      resizable
      align="center"
      label="Publié">
      <template slot-scope="scope">
        <i v-if="scope.row.published" class="accent-text el-icon-success"></i>
        <i v-else class="el-icon-error"></i>
      </template>
    </el-table-column>
    <el-table-column
      prop="logo"
      resizable
      align="center"
      label="Logo">
      <template slot-scope="scope">
        <span v-if="logoExists(scope.row.galeries)">
          <i slot="reference" class="fs-18 mdi mdi-image-outline"> </i>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="mainImage"
      resizable
      align="center"
      label="Image princ.">
      <template slot-scope="scope">
        <span v-if="mainImageExists(scope.row.galeries)">
          <i slot="reference" class="fs-18 mdi mdi-image-outline"> </i>
        </span>
      </template>
    </el-table-column>
    </el-table-column>
    <el-table-column
      align="right"
      label="Dernière mise à jour">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ _moment(scope.row.updatedDate) }}</span>
      </template>
    </el-table-column>
  </el-table>
  </div>
</template>
<script>
import cmsAPI from '@/services/API/cmsAPI'
import HeaderCard from '@/components/header-card'
import Provider from './provider'
import moment from 'moment-timezone'
import PortausLink from '@/components/portaus-link'
import Promise from 'bluebird'
import Pagination from '@/components/pagination'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'Providers',
	data() {
		return {
      selected: [],
      window: {
        width: 0,
        height: 0
      },
		}
	},
  components: {
    HeaderCard,
    PortausLink,
    Pagination,
  },
  computed: {
    searchModel : {
      set(val){ this.setSearch(val)},
      get(){return this.search}
    },
    ...mapState('cmsProviders',['cmsProviders','search', 'loading', 'currentPage', 'totalPages','limit','count']),
    ...mapGetters('cmsProviders',['isFiltered'])
  },
  methods : {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getTableWidth() {
      return (this.window.width-320);
    },
    logoExists(images) {
      let exists = false;
      _.forEach(images, img => {
        if (img.isProviderLogo) {
          exists = true;
        }
      })
      return exists;
    },
    mainImageExists (images) {
      let exists = false;
      _.forEach(images, img => {
        if (img.isProviderMainImage === true) {
          exists = true;
        }
      })
      return exists;
    },
    getLogoThumbnailLink (images) {
      const logo = _.find(images, i => i.isProviderLogo);
      return _.get(logo, 'thumbnailLink');
    },
    mainImageExists(images) {
      let exists = false;
      _.forEach(images, img => {
        if (img.isProviderMainImage) {
          exists = true;
        }
      })
      return exists;
    },
    deleteSelectedProviders(){
      this.$confirm('Êtes vous sûr de vouloir supprimer les producteurs sélectionnés?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(()=>{
          return Promise.each(this.selected, p=>{
            return cmsAPI.deleteProvider(p.id);
          }).then(()=>this.refreshProviders())
        }).catch(err=>{
          if(err=="cancel"){
            this.$message('Suppression annulée!');
          }else{
            console.log(err);
            this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
          }
        })
    },
    _moment(datetime, format='l'){
      return moment(datetime).format(format);
		},
    openProviderEditor(){
      this.$router.push('/settings/CMS/provider');
    },
    refreshProviders(){
      this.fetchCMSProviders();
    },
    handleSelectionChange(val){
      this.selected = val;
    },
    ...mapActions('cmsProviders',['fetchCMSProviders','setSearch', 'fetchPreviousPage', 'fetchNextPage'])
  },
  mounted(){
    this.fetchCMSProviders();
  },
  created(){

    window.addEventListener('resize', this.handleResize)
    this.handleResize();
	},
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';


</style>
